// extracted by mini-css-extract-plugin
export default {"tableSize":"styles_tableSize__Hlecc","tableBodySizeEven":"styles_tableBodySizeEven__Xses7","tableBodySizeOdd":"styles_tableBodySizeOdd__c2Fi4"};